<template>
  <v-dialog v-model="dialog" persistent max-width="420px">
    <v-card>
      <v-card-title class="py-6">Xác nhận sửa chuyên cần</v-card-title>
      <v-card-text style="color: black">
        Thay đổi chuyên cần từ <strong>Vắng mặt</strong> sang <strong>Có mặt</strong> sẽ gửi tin nhắn và thông báo để
        nhắc nhờ phụ huynh và học sinh quẹt thẻ. Xác nhận đổi?
      </v-card-text>
      <v-card-actions class="px-6 pb-6 pt-0">
        <v-btn color="blue darken-4" text @click="close" outlined>Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    state: Boolean,
  },
  mounted() {},
  computed: {},
  watch: {
    state() {
      this.dialog = true
    },
  },
  methods: {
    close() {
      this.dialog = false
    },
    confirm() {
      this.$emit('confirm', 'swipeRemind')
      this.close()
    },
  },
}
</script>

<style></style>
